<template>
    <div>
        <slot 
            :data="data"
            :dataPlan="dataPlan"
            :crearPlan="crearPlan"
            :planSeleccionado="planSeleccionado"
            :seleccionarPlan="seleccionarPlan"
            :seleccionarArea="seleccionarArea" 
            :seleccionarAsignatura="seleccionarAsignatura" 
            :crearAsignatura="crearAsignatura" 
            :actualizarPlan="actualizarPlan" 
            :actualizarArea="actualizarArea"
            :actualizarAsignatura="actualizarAsignatura"
            :crearArea="crearArea">
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    mounted() {
        const vm = this;
        const asignaturaForm = $('#editarAsignatura-form');
        const areaForm = $('#editarArea-form');
        const planForm = $('#editarPlan-form');
        vm.asignaturasListado();
        
        vm.$on('submitAsignatura', function() {
            const data = asignaturaForm.serialize();
            vm.guardarAsignatura(data);
        });

        vm.$on('submitArea', function() {
            const data = areaForm.serialize();
            vm.guardarArea(data);
        });

        vm.$on('submitPlan', function() {
            const data = planForm.serialize();
            vm.guardarPlan(data);
        });
    },
    data() { return {
        dataPlan: {},
        data: [],
        planSeleccionado: -1,
        areaSeleccionada: -1,
        asignaturaSeleccionada: -1,
    }},
    methods: {
        guardarAsignatura(data) {
            axios.post('/asignaturas/guardarAsignatura/'+this.asignaturaSeleccionada, data).then(res => {
                toastr["success"]('Asignatura actualizada', "Éxito");
                
                const index = this.data.findIndex(a => a.id == res.data.plan_estudios_id);
                const index2 = this.data[index].areas.findIndex(b => b.id == res.area_asignaturas_id);
                this.data[index].areas[index2] = res.data;

                this.$emit('kiraModalFormClose');
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        guardarArea(data) {
            axios.post('asignaturas/guardarArea/'+this.areaSeleccionada, data).then(res => {
                const index = this.data.findIndex(a => a.id == this.planSeleccionado);
                const index2 = this.data[index].areas.findIndex(b => b.id == res.data.id);
                this.data[index].areas[index2].nombre = res.data.nombre
                this.$emit('kiraModalFormClose');
            });
        },
        guardarPlan(data) {
            axios.post('/asignaturas/guardarPlan/'+this.planSeleccionado, data).then(res => {
                const index = this.data.findIndex(a => a.id == res.data.id);
                this.data[index].nombre = res.data.nombre;
                this.data[index].programa_id = res.data.programa_id;
                this.data[index].programa = res.data.programa;
                this.data[index].clave = res.data.clave;
                this.data[index].fecha_creacion = res.data.fecha_creacion;
                toastr["success"]('Plan actualizado', "Éxito");
                this.$emit('kiraModalFormClose');
            });
        },
        asignaturasListado() {
            axios.get('asignaturas/listado').then(res => {
                this.data = res.data.data;
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearPlan() {
            axios.post('/asignaturas/crearPlan', this.dataPlan).then(res => {
                toastr["success"]('Nuevo plan de estudio agregado', "Éxito");
                this.data = this.data.concat(res.data.plan);
                this.$emit('kiraModalFormClose');
                this.dataPlan = {};
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearArea() {
            this.dataPlan.plan_estudios_id = this.planSeleccionado;
            axios.post('/asignaturas/crearArea', this.dataPlan).then(res => {
                toastr["success"]('Nueva área agregada', "Éxito");

                const index = this.data.findIndex(a => a.id == res.data.area.plan_estudios_id);
                this.data[index].areas = this.data[index].areas.concat(res.data.area);
                
                this.$emit('kiraModalFormClose');
                this.dataPlan = {};
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearAsignatura() {
            this.dataPlan.plan_estudios_id = this.planSeleccionado;
            this.dataPlan.area_asignaturas_id = this.areaSeleccionada;
            axios.post('/asignaturas/crearAsignatura', this.dataPlan).then(res => {
                toastr["success"]('Nueva asignatura creada', "Éxito");

                const index = this.data.findIndex(a => a.id == res.data.asignatura.plan_estudios_id);
                const index2 = this.data[index].areas.findIndex(b => b.id == res.data.asignatura.area_asignaturas_id);
                this.data[index].areas[index2].asignatura = res.data.asignatura;

                this.$emit('kiraModalFormClose');
                this.dataPlan = {};
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        actualizarPlan() {
            this.$emit('submitPlan');
        },
        actualizarArea() {
            this.$emit('submitArea');
        },
        actualizarAsignatura() {
            this.$emit('submitAsignatura');
        },
        seleccionarPlan(plan_id) {
            this.planSeleccionado = plan_id;
        },
        seleccionarArea(plan_id, area_id) {
            this.planSeleccionado = plan_id;
            this.areaSeleccionada = area_id;
        },
        seleccionarAsignatura(asignatura_id) {
            this.asignaturaSeleccionada = asignatura_id;
        }
    },
}
</script>